$(document).ready(function () {
    populateTotalJobCountUp();
    $('.js-slick').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        centerMode: false,
        arrows: true,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    centerMode: false,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    centerMode: true,
                    arrows: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    populateFavoriteJobs();


    //Main Search Avanced options
    $('.js-home-advanced-search + .dropdown-menu > .dropdown-item ').on('click', function (e) {
        e.preventDefault();
        const selText = $(this).text();
        const domain = $(this).data('domain');
        const $href = $(this).parents('.dropdown-menu').prev();
        const $hiddenInput = $('.js-main-search-selected-domain');
        if (domain) {
            $href.html(selText);
            $hiddenInput.attr('name', 'JobDomain.' + domain);
            $hiddenInput.val(true);
        }
        else {
            $href.html('RECHERCHE AVANC&Eacute;E');
            $hiddenInput.attr('name', 'JobDomain');
            $hiddenInput.val(false);
        }
    });
});


function populateFavoriteJobs() {
    const $jobList = $('.js-home-job-list');

    $.ajax({
        url: "/Home/GetHomepageOffers",
        type: 'GET',
        success: function (data) {
            $jobList.html(data);
        },
        error: function (data) {
            console.log("Unexpected error occured while loading job offers.");
        }
    });

}

function populateTotalJobCountUp() {
    $.ajax({
        url: "/Home/GetTotalJobCountAsync",
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (resp) {
            console.log(resp);
            if (resp.jobCount) {
                var countUp = new CountUp('jobCountUpElt', resp.jobCount, {
                    separator: ' '
                });
                countUp.start();
            }
        },
        error: function () {
            console.log("Unexpected error occured while loading total job offers count.");
        }
    });
}